import {
  SUBSCRIBE_REQUEST,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBE_FAILURE,
  SUBSCRIBE_RESET,
} from '../actions/subscribeActions';

const initialState = { loading: false, success: false, error: null, message: null };

export default function subscribeReducer(state = initialState, action) {
  switch (action.type) {
    case SUBSCRIBE_REQUEST:
      return { ...state, loading: true, success: false, error: null };
    case SUBSCRIBE_SUCCESS:
      return { ...state, loading: false, success: true, message: action.payload };
    case SUBSCRIBE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SUBSCRIBE_RESET:
      return initialState;
    default:
      return state;
  }
}
